import { InputField } from 'components/molecules/formFields';
import React from 'react';

import { FormBuilder } from './form-builder';
import { BaseFormProps } from './types';

export const ContactSupportForm = ({ onBack, onSubmit }: BaseFormProps<any>) => {
  const formFields = [
    {
      component: InputField,
      fieldKey: 'message',
      label: 'MESSAGE',
      type: 'textarea',
      multiline: true,
      rows: 4,
      validation: {
        validate: (currentValue: string) =>
          currentValue.trim().length > 0 || 'Please enter a message',
      },
    },
  ];

  return <FormBuilder formFields={formFields} onBack={onBack} onSubmit={onSubmit} />;
};
